import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useCumulativeReportFilterFields } from './hooks/useCumulativeReportFilterFields';

export const CumulativeReportListFilterChips: React.FC = () => {
  const fields = useCumulativeReportFilterFields();

  return <FilterChips fields={fields} />;
};
